import type { PostResumo } from "@/lib/blog.functions";

export interface ConteudosProps {
  titulo: string;
  artigos: PostResumo[];
}

/** Mostra só artigos realmente publicados. Sem artigo, a seção não aparece. */
export function Conteudos({ titulo, artigos }: ConteudosProps) {
  if (!artigos.length) return null;
  return (
    <section className="conteudos">
      <div className="container">
        <p className="sobretitulo">CONTEÚDO</p>
        <h2>{titulo}</h2>
        <ul className="conteudos-grade">
          {artigos.map((a) => (
            <li key={a.slug}>
              <a href={`/blog/${a.slug}/`}>
                {a.capa ? (
                  <span className="conteudo-foto">
                    <img
                      src={a.capa.path}
                      alt={a.capa.alt}
                      width={a.capa.width ?? 420}
                      height={a.capa.height ?? 340}
                      loading="lazy"
                    />
                  </span>
                ) : null}
                <span className="conteudo-rotulo">
                  ARTIGO{a.categoria ? ` · ${a.categoria.label.toUpperCase()}` : ""}
                </span>
                <span className="conteudo-titulo">{a.title}</span>
                {a.subtitle || a.direct_answer ? (
                  <span className="conteudo-texto">{a.subtitle ?? a.direct_answer}</span>
                ) : null}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
